import { Injectable } from '@angular/core';
import { CoreService } from '../../../core/core.service';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../../environments/environment';

@Injectable()
export class LeoService {
  constructor(private coreService: CoreService) { }

  //Save the LEO form 
  SaveLeo(postdata) {
    return this.coreService.post('Forms/SaveLeo/', postdata);
  }

  //Get the states to show in the State dropdown
  GetStates(provider) {
    var states = this.coreService.post('Forms/GetStates/', '');
    return states;
  }

  //Get all Michigan counties from the database to show in the Counties dropdown
  GetCounties(provider) {
    return this.coreService.post('Forms/GetCounty/', '');
  }
}

